// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".wNXwhYtux{background-color:var(--codeblock-bg)}.wNXwhYtux .tvn2TnN7x{white-space:pre;overflow-x:auto;margin:auto 0;font-size:12px}.wNXwhYtux ._42u6IZ1Nx{margin:auto 0}._2DWHm5Jmx{font-family:\"SFMono-Regular\",Consolas,\"Liberation Mono\",Menlo,Courier,monospace;display:inline-block;padding:4px;line-height:1;background-color:white;white-space:pre;font-size:12px}._4ZN9ZDAAx{background-color:var(--terminal-bg)}._4t7tRn8Px{background-color:var(--codeblock-bg)}._42u6IZ1Nx{font-family:\"SFMono-Regular\",Consolas,\"Liberation Mono\",Menlo,Courier,monospace;color:var(--always-light-text)}._42u6IZ1Nx::before{content:\"$\";margin-right:8px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"code-block": "wNXwhYtux " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-xs"] + "",
	"codeBlock": "wNXwhYtux " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-xs"] + "",
	"code": "tvn2TnN7x",
	"terminal": "_42u6IZ1Nx",
	"inline-code-block": "_2DWHm5Jmx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["rounded-sm"] + "",
	"inlineCodeBlock": "_2DWHm5Jmx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["rounded-sm"] + "",
	"dark": "_4ZN9ZDAAx",
	"light": "_4t7tRn8Px"
};
module.exports = exports;
